import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@ember/types';
import { logout as apiLogout } from '../lib/auth.js';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isLoading: false,

      setUser: (user) => set({ user }),
      setLoading: (isLoading) => set({ isLoading }),

      logout: async () => {
        try {
          await apiLogout();
        } catch {
          // ignore — clear local state regardless
        }
        set({ user: null });
      },
    }),
    {
      name: 'ember-auth',
      // Only persist the user object, not loading state
      partialize: (state) => ({ user: state.user }),
    },
  ),
);
